export default (theme) => ({
  root: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  documentsBarContainer: {
    padding: "8px 30px",
    backgroundColor: "#f3f3f3",
  },
  documentsBarTitle: {
    fontSize: 13,
    fontWeight: 600,
  },
  documentsTableContainer: {
    padding: "18px",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 0,
    color: "#525252",
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
  panelHeader: {
    marginTop: 15,
    fontSize: 12,
    fontWeight: 600,
    marginBottom: "1rem",
  },
  fieldWidth: {
    width: 300,
    margin: 10,
    marginTop: 0,
  },
  fieldWidthSmall: {
    width: 300,
    margin: 10,
    marginTop: 0,
  },
  container: {
    marginBottom: 20,
  },
  uploadContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
});
